<script>
  import { profile } from "#src/stores/auth.js";
  let confirmedGsUpdate = false;
</script>

<div class="text-xs space-y-2">
  <div class="p-4 space-y-2">
    <p class="text-red-500">
      *Glazier Studio installations require an update in order to correctly import reports from Shape
      Exchange. If you have not already received the fixed update from DeMichele, you will need to do so, even
      if you have the latest version.
    </p>
    <p class="text-red-500">
      DeMichele's support team can provide the update to you directly; please reach them at <strong
        >480-985-4926</strong>
      before attempting to import the Shape Exchange report into Glazier Studio. Please reach out to help@shape.exchange
      if you have any questions or issues regarding this update.
    </p>
  </div>
  <div class="flex justify-end gap-1 items-center">
    <input type="checkbox" bind:checked={confirmedGsUpdate} />
    <span>I have installed the update</span>
  </div>
  <div class="flex justify-end">
    <button class="btn btn-primary" on:click={() => profile.confirmGsUpdate()} disabled={!confirmedGsUpdate}>
      Proceed
    </button>
  </div>
</div>
